export default function Contact() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-16 text-center">
      <h2 className="text-4xl font-bold text-blue-600 mb-6">Get in Touch</h2>

      <p className="text-lg text-gray-700 mb-4">
        Have questions or feedback? We’d love to hear from you!
      </p>

      <p className="text-lg text-gray-700 mb-8">
        Email us at{" "}
        <a
          href="mailto:info@popalooza.com.au"
          className="text-blue-600 font-semibold hover:underline"
        >
          info@popalooza.com.au
        </a>
      </p>

      <div className="flex justify-center space-x-6">
        <a
          href="https://www.facebook.com/PopaloozaFun"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition"
        >
          Facebook
        </a>
        <a
          href="https://www.instagram.com/popaloozafun"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-pink-500 text-white px-4 py-2 rounded-lg shadow hover:bg-pink-600 transition"
        >
          Instagram
        </a>
        <a
          href="https://www.tiktok.com/@popaloozafun"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-black text-white px-4 py-2 rounded-lg shadow hover:bg-gray-800 transition"
        >
          TikTok
        </a>
        <a
          href="https://www.youtube.com/@PopaloozaFun"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-red-600 text-white px-4 py-2 rounded-lg shadow hover:bg-red-700 transition"
        >
          YouTube
        </a>
      </div>
    </section>
  );
}
